import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Check, X, Mail } from 'lucide-react';

export default function InvitationsModal({ invitations, onAction, onClose }) {
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="bg-white border-[#EAE6DF]">
        <DialogHeader>
          <DialogTitle className="text-[#2F3E3B]">Invitationer</DialogTitle>
        </DialogHeader>
        <div className="py-2">
          {invitations.length === 0 ? (
            <div className="text-center py-6">
              <Mail className="w-10 h-10 text-[#EAE6DF] mx-auto mb-3" />
              <p className="text-[#5C706A] font-sans text-sm">Ingen ventende invitationer</p>
            </div>
          ) : (
            <div className="space-y-3">
              {invitations.map(inv => (
                <div key={inv.id} className="p-3 bg-[#F9F8F6] rounded-lg" data-testid={`invitation-${inv.id}`}>
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <p className="font-sans text-sm font-medium text-[#2F3E3B]">
                        {inv.inviter_name || 'En bruger'} inviterer dig til:
                      </p>
                      <p className="font-sans text-sm text-[#7F9C82] font-medium">{inv.list_name}</p>
                      <Badge variant="outline" className="text-[10px] mt-1 border-[#EAE6DF] text-[#5C706A]">
                        {inv.permission === 'write' ? 'Skrive-adgang' : 'Læse-adgang'}
                      </Badge>
                    </div>
                    <div className="flex gap-1 shrink-0">
                      <Button size="sm" onClick={() => onAction(inv.id, 'accept')}
                        className="bg-[#7F9C82] hover:bg-[#658368] text-white h-8 px-3 font-sans"
                        data-testid={`accept-invitation-${inv.id}`}>
                        <Check className="w-3.5 h-3.5 mr-1" />Accepter
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => onAction(inv.id, 'decline')}
                        className="border-[#C85547] text-[#C85547] hover:bg-red-50 h-8 px-3 font-sans"
                        data-testid={`decline-invitation-${inv.id}`}>
                        <X className="w-3.5 h-3.5" />
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="font-sans" data-testid="close-invitations-modal">Luk</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
